import { render, staticRenderFns } from "./AloneBox.vue?vue&type=template&id=21f18ce2&scoped=true"
import script from "./AloneBox.vue?vue&type=script&lang=js"
export * from "./AloneBox.vue?vue&type=script&lang=js"
import style0 from "./AloneBox.vue?vue&type=style&index=0&id=21f18ce2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f18ce2",
  null
  
)

export default component.exports